<form
  [formGroup]="insuranceClaimRejectReasonForm"
  (ngSubmit)="onSubmit()"
  [hasUnsavedData]="insuranceClaimRejectReasonForm"
>
  <button type="submit" hidden="hidden"></button>

  <div class="row">
    <div class="col-lg-12 col-12">
      <div class="form-group row">
        <div class="col">
          <label class="col col-form-label-sm" translate>
            INSURANCE_CLAIM_LBL_REJECT_REASON
          </label>
          <textarea
            formControlName="rejectReason"
            class="form-control form-control-sm height-size"
          >
          </textarea>
        </div>
      </div>
    </div>
  </div>
  @if (this.rejectReasonMaxLength()) {
    @let rejectReasonControl =
      this.insuranceClaimRejectReasonForm.get('rejectReason');
    @let maxLength = this.rejectReasonMaxLength() ?? 0;
    <small
      ><span [class.maxLengthExceeded]="rejectReasonControl?.value?.length > maxLength"
        >{{ rejectReasonControl ? rejectReasonControl?.value?.length : 0 }}
      </span>
      / {{ this.rejectReasonMaxLength() }}
    </small>
  }
</form>
